import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  class: "dropdown multi-select",
  ref: "dropDownElement"
}
const _hoisted_2 = ["disabled"]
const _hoisted_3 = {
  class: "dropdown-menu",
  ref: "dropDownMenu"
}
const _hoisted_4 = { class: "input-group p-1" }
const _hoisted_5 = ["placeholder", "disabled"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "input-group-append" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "input-group-text" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fas fa-search" })
  ])
], -1 /* HOISTED */)
const _hoisted_7 = {
  key: 0,
  class: "dropdown-divider"
}
const _hoisted_8 = { class: "content" }
const _hoisted_9 = { class: "dropdown-item p-0 my-1" }
const _hoisted_10 = { class: "form-check ms-0 ps-0" }
const _hoisted_11 = { class: "form-check-label checkbox-hide text-center" }
const _hoisted_12 = ["disabled"]
const _hoisted_13 = {
  key: 0,
  class: "fw-bold text-center mb-0"
}
const _hoisted_14 = { class: "form-check" }
const _hoisted_15 = ["value", "checked", "onChange", "disabled"]
const _hoisted_16 = ["innerHTML"]
const _hoisted_17 = ["innerHTML"]
const _hoisted_18 = { class: "name-text" }
const _hoisted_19 = { key: 1 }
const _hoisted_20 = { class: "form-check" }
const _hoisted_21 = ["value", "checked", "onChange", "disabled"]
const _hoisted_22 = ["innerHTML"]
const _hoisted_23 = { class: "name-text" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "dropdown-divider" }, null, -1 /* HOISTED */)
const _hoisted_25 = { class: "px-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      class: _normalizeClass(`btn btn-light bg-white dropdown-toggle ${_ctx.disabled ? 'disabled' : ''} min-w-100`),
      type: "button",
      "data-bs-toggle": "dropdown",
      "aria-haspopup": "true",
      "aria-expanded": "false",
      disabled: _ctx.disabled
    }, [
      _createElementVNode("span", null, _toDisplayString(_ctx.getButtonText), 1 /* TEXT */)
    ], 10 /* CLASS, PROPS */, _hoisted_2),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _withDirectives(_createElementVNode("input", {
          type: "text",
          class: "form-control",
          placeholder: _ctx.getSearchPlaceholder,
          ref: "searchInput",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.search) = $event)),
          disabled: _ctx.disabled
        }, null, 8 /* PROPS */, _hoisted_5), [
          [_vModelText, _ctx.search]
        ]),
        _hoisted_6
      ]),
      (!_ctx.search)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7))
        : _createCommentVNode("v-if", true),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("label", _hoisted_11, [
              _createElementVNode("input", {
                class: "form-check-input",
                type: "checkbox",
                value: null,
                disabled: _ctx.disabled,
                onChange: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.closeDropDown()), ["prevent"]))
              }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_12),
              _createTextVNode(" -- Select " + _toDisplayString(_ctx.labelText) + " -- ", 1 /* TEXT */)
            ])
          ])
        ]),
        (_ctx.hasGroupLabel && !_ctx.isList)
          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(Object.keys(_ctx.filteredOptions), (groupName) => {
              return (_openBlock(), _createElementBlock("div", null, [
                (groupName && _ctx.filteredOptions[groupName].length > 0)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_13, _toDisplayString(groupName), 1 /* TEXT */))
                  : _createCommentVNode("v-if", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredOptions[groupName], (option) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: _normalizeClass(`dropdown-item p-0 ps-1 my-1 ${option.value == _ctx.selectedValue ? 'bg-primary' : ''}`)
                  }, [
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("label", {
                        class: _normalizeClass(`form-check-label checkbox-hide w-100 d-flex align-items-center white-space-nowrap ${option.relationship === _ctx.EmployeePreferenceEnum.DoNotSend ? 'disabled' : ''}`)
                      }, [
                        _createElementVNode("input", {
                          class: "form-check-input",
                          type: "checkbox",
                          value: option.value,
                          checked: _ctx.selectedOption.includes(option.value),
                          onChange: _withModifiers(($event: any) => (_ctx.closeDropDown(option)), ["prevent"]),
                          disabled: option.relationship === _ctx.EmployeePreferenceEnum.DoNotSend || _ctx.disabled
                        }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_15),
                        _createElementVNode("span", {
                          class: "show-icons",
                          innerHTML: option.relationshipIcons
                        }, null, 8 /* PROPS */, _hoisted_16),
                        (_ctx.showIcons)
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 0,
                              class: "show-icons",
                              innerHTML: option.icons
                            }, null, 8 /* PROPS */, _hoisted_17))
                          : _createCommentVNode("v-if", true),
                        _createElementVNode("span", _hoisted_18, _toDisplayString(option.displayText), 1 /* TEXT */)
                      ], 2 /* CLASS */)
                    ])
                  ], 2 /* CLASS */))
                }), 256 /* UNKEYED_FRAGMENT */))
              ]))
            }), 256 /* UNKEYED_FRAGMENT */))
          : (_openBlock(), _createElementBlock("div", _hoisted_19, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredList, (option) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: _normalizeClass(`dropdown-item p-0 ps-1 my-1 ${option.value == _ctx.selectedValue ? 'bg-primary' : ''}`)
                }, [
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("label", {
                      class: _normalizeClass(`form-check-label checkbox-hide w-100 d-flex align-items-center white-space-nowrap ${option.relationship === _ctx.EmployeePreferenceEnum.DoNotSend ? 'disabled' : ''}`)
                    }, [
                      _createElementVNode("input", {
                        class: "form-check-input",
                        type: "checkbox",
                        value: option.value,
                        checked: _ctx.selectedOption.includes(option.value),
                        onChange: _withModifiers(($event: any) => (_ctx.closeDropDown(option)), ["prevent"]),
                        disabled: option.relationship === _ctx.EmployeePreferenceEnum.DoNotSend || _ctx.disabled
                      }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_21),
                      _createElementVNode("span", {
                        class: "show-icons",
                        innerHTML: option.relationshipIcons
                      }, null, 8 /* PROPS */, _hoisted_22),
                      _createElementVNode("span", _hoisted_23, _toDisplayString(option.displayText), 1 /* TEXT */)
                    ], 2 /* CLASS */)
                  ])
                ], 2 /* CLASS */))
              }), 256 /* UNKEYED_FRAGMENT */))
            ]))
      ]),
      _hoisted_24,
      _createElementVNode("div", _hoisted_25, [
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-xs btn-outline-dark w-100",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.closeDropDown()))
        }, "Close")
      ])
    ], 512 /* NEED_PATCH */)
  ], 512 /* NEED_PATCH */))
}